/**
 * v-action使用:
 */
 import { getRrealFile } from '@/api/utils'
 import Vue from 'vue'
 const action = Vue.directive('action', {
   inserted: (el, binding, vnode) => {
     filterPermission(el, binding, vnode)
   }
 })
 const down = Vue.directive('down', {
   inserted: (el, binding, vnode) => {
     el.style.cssText = 'cursor: pointer;color:write;'
     el.addEventListener( 'click', () => {
       const {fileUrl,fileName} = binding.value
       if (!fileUrl) {
         return
       }
       getBlob(fileUrl,fileName)
       //解密url
      //  getRrealFile({url:fileUrl}).then((res :any) => {
      //    const {status,data} = res
      //    if(status === 0){
         
      //    }
      //  })
      
     })
   }
 } )
 const getBlob = (fileUrl: string,fileName: string) => {
    // 这里是将url转成blob地址，
    fetch(fileUrl).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
     const url = window.URL.createObjectURL(new Blob([blob]))
     const a = document.createElement('a')
     a.style.display = 'none'
     a.href = url
     fileName&&a.setAttribute('download', fileName)
     document.body.appendChild(a)
     a.click()
     document.body.removeChild(a)
     window.URL.revokeObjectURL(url)
   })
 }
 export const filterPermission = (el: any, binding: any, vnode: any) => {
   const permissionList = []
   const authList = (vnode.context.$route && vnode.context.$route.meta.permissions) || []
   for (const auth of authList) {
     permissionList.push(auth)
   }
   if (!permissionList.length) {
     el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
     return
   }
   if (!permissionList.includes(binding.value)) {
     el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
   }
 }
 export default action
 